import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { mediaFluctuationStatistics } from 'lib/api/media';

import MbCheckbox from 'components/atoms/MbCheckbox';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import MediaFluctuationStatisticsGraph from './MediaFluctuationStatisticsGraph';

const MediaFluctuationStatistics = () => {
  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().add(-2, 'day').format('YYYYMMDD'),
    eDate: moment().add(-2, 'day').format('YYYYMMDD'),
    diffSDate: moment().add(-1, 'day').format('YYYYMMDD'),
    diffEDate: moment().add(-1, 'day').format('YYYYMMDD'),
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    displayType: 'mediaId',
    advrtsAmtFlag: false,
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    setInitialization(false);
  }, [params]);

  const customized = {
    RAF_ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'RAF_ADVRTS_AMT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'RAF_ADVRTS_AMT');
        const valObj2 = getHeadObj(headsMap, 'RAF_RATE_ADVRTS_AMT');

        return (
          <>
            {makeRowColumn(
              rowObj['RAF_ADVRTS_AMT'],
              valObj.type,
              valObj.format
            )}
            <br />(
            {makeRowColumn(
              rowObj['RAF_RATE_ADVRTS_AMT'],
              valObj2.type,
              valObj2.format
            )}
            )
          </>
        );
      },
    },
    RAF_RATE_ADVRTS_AMT: {
      merged: true,
    },
    RAF_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'RAF_PAR_EPRS_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'RAF_PAR_EPRS_CNT');
        const valObj2 = getHeadObj(headsMap, 'RAF_RATE_PAR_EPRS_CNT');

        return (
          <>
            {makeRowColumn(
              rowObj['RAF_PAR_EPRS_CNT'],
              valObj.type,
              valObj.format
            )}
            <br />(
            {makeRowColumn(
              rowObj['RAF_RATE_PAR_EPRS_CNT'],
              valObj2.type,
              valObj2.format
            )}
            )
          </>
        );
      },
    },
    RAF_RATE_PAR_EPRS_CNT: {
      merged: true,
    },
    RAF_REQ_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'RAF_REQ_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'RAF_REQ_CNT');
        const valObj2 = getHeadObj(headsMap, 'RAF_RATE_REQ_CNT');

        return (
          <>
            {makeRowColumn(rowObj['RAF_REQ_CNT'], valObj.type, valObj.format)}
            <br />(
            {makeRowColumn(
              rowObj['RAF_RATE_REQ_CNT'],
              valObj2.type,
              valObj2.format
            )}
            )
          </>
        );
      },
    },
    RAF_RATE_REQ_CNT: {
      merged: true,
    },
    RAF_CLICK_RATE: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'RAF_CLICK_RATE').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'RAF_CLICK_RATE');
        const valObj2 = getHeadObj(headsMap, 'RAF_RATE_CLICK_RATE');

        return (
          <>
            {makeRowColumn(
              rowObj['RAF_CLICK_RATE'],
              valObj.type,
              valObj.format
            )}
            <br />(
            {makeRowColumn(
              rowObj['RAF_RATE_CLICK_RATE'],
              valObj2.type,
              valObj2.format
            )}
            )
          </>
        );
      },
    },
    RAF_RATE_CLICK_RATE: {
      merged: true,
    },
    RAF_SESSION_ORDER_AMT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'RAF_SESSION_ORDER_AMT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'RAF_SESSION_ORDER_AMT');
        const valObj2 = getHeadObj(headsMap, 'RAF_RATE_SESSION_ORDER_AMT');

        return (
          <>
            {makeRowColumn(
              rowObj['RAF_SESSION_ORDER_AMT'],
              valObj.type,
              valObj.format
            )}
            <br />(
            {makeRowColumn(
              rowObj['RAF_RATE_SESSION_ORDER_AMT'],
              valObj2.type,
              valObj2.format
            )}
            )
          </>
        );
      },
    },
    RAF_RATE_SESSION_ORDER_AMT: {
      merged: true,
    },
    SESSION_ROAS: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'SESSION_ROAS').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'SESSION_ROAS');
        const valObj2 = getHeadObj(headsMap, 'MOB_SESSION_ROAS');

        return (
          <>
            {makeRowColumn(rowObj['SESSION_ROAS'], valObj.type, valObj.format)}
            <br />(
            {makeRowColumn(
              rowObj['MOB_SESSION_ROAS'],
              valObj2.type,
              valObj2.format
            )}
            )
          </>
        );
      },
    },
    MOB_SESSION_ROAS: {
      merged: true,
    },
    DIFF_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'DIFF_SESSION_ROAS').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'DIFF_SESSION_ROAS');
        const valObj2 = getHeadObj(headsMap, 'DIFF_MOB_SESSION_ROAS');

        return (
          <>
            {makeRowColumn(
              rowObj['DIFF_SESSION_ROAS'],
              valObj.type,
              valObj.format
            )}
            <br />(
            {makeRowColumn(
              rowObj['DIFF_MOB_SESSION_ROAS'],
              valObj2.type,
              valObj2.format
            )}
            )
          </>
        );
      },
    },
    DIFF_MOB_SESSION_ROAS: {
      merged: true,
    },

    RAF_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'RAF_SESSION_ROAS').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'RAF_SESSION_ROAS');
        const valObj2 = getHeadObj(headsMap, 'RAF_MOB_SESSION_ROAS');
        const valObj3 = getHeadObj(headsMap, 'RAF_RATE_MOB_SESSION_ROAS');

        return (
          <>
            {makeRowColumn(
              rowObj['RAF_SESSION_ROAS'],
              valObj.type,
              valObj.format
            )}
            <br />(
            {makeRowColumn(
              rowObj['RAF_MOB_SESSION_ROAS'],
              valObj2.type,
              valObj2.format
            )}
            )
            <br />(
            {makeRowColumn(
              rowObj['RAF_RATE_MOB_SESSION_ROAS'],
              valObj3.type,
              valObj3.format
            )}
            )
          </>
        );
      },
    },
    RAF_MOB_SESSION_ROAS: {
      merged: true,
    },

    RAF_RATE_SESSION_ROAS: {
      merged: true,
    },
    RAF_RATE_MOB_SESSION_ROAS: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleChangeValue = (e) => {
    const { name } = e.target;
    const newParams = {
      ...params,
      [name]: !params[name],
    };
    getParam(newParams);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDiffDate
        />
        <FormControlLabel
          control={
            <MbCheckbox
              name="advrtsAmtFlag"
              onChange={handleChangeValue}
              checked={params.advrtsAmtFlag}
            />
          }
          label="중지매체 제외"
        />
      </NewFilterWrap>

      <MediaFluctuationStatisticsGraph
        params={{ ...params, advrtsAmtFlag: params.advrtsAmtFlag ? 'Y' : 'N' }}
      />
      <NewTableContainer
        dataReqPromise={mediaFluctuationStatistics}
        getParam={getParam}
        params={{ ...params, advrtsAmtFlag: params.advrtsAmtFlag ? 'Y' : 'N' }}
        customized={customized}
      />
    </>
  );
};

export default withRouter(MediaFluctuationStatistics);
